var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
var __spread = (this && this.__spread) || function () {
    for (var ar = [], i = 0; i < arguments.length; i++) ar = ar.concat(__read(arguments[i]));
    return ar;
};
import { DeviceActions } from './devices.actions';
import { getInputDevices, getOutputDevices, getVideoInputDevices, differenceByDeviceUID, mergeByDeviceUID, updateDeviceHistory, getNextDevice, deviceUID, devicesEqual, areDeviceListsEqual } from './devices.utils';
import { isEmpty, find } from 'lodash';
export var INITIAL_STATE = {
    allDevices: [],
    availableInputDevices: [],
    selectedInputDevice: null,
    selectInputReady: true,
    selectedInputDeviceHistory: [],
    availableVideoInputDevices: [],
    selectedVideoInputDevice: null,
    selectedVideoInputDeviceHistory: [],
    selectedVideoInputBitRate: 500,
    availableOutputDevices: [],
    selectedOutputDevice: null,
    selectedOutputDeviceHistory: [],
    labelledOutputDevices: new Map(),
    screenShare: null,
    videoTrackConstraints: { width: 1280, height: 720 }
};
var setAvailableOutputDevice = function (availableOutputDevices, outputDevicesRemovedList, selectedOutputDeviceInfo) {
    var fallbackDevice = getNextDevice(selectedOutputDeviceInfo.selectedOutputDeviceHistory, availableOutputDevices);
    if (selectedOutputDeviceInfo.selectedOutputDevice) {
        /**
           * We re-select the device in those cases
           * 1. If the previously selected device is NOT in the list of available devices, that device is not available
           *    Example: perviously selected device is plugged out.
           * 2. If the previously selected device is NOT in the current selected device or the current default device
           *    Nuanced case: when we have empty history and we plug in new device and operational system places that device on top of the device list
           *    then this device became devices[0] which means default device for this package
         */
        if ((!isEmpty(outputDevicesRemovedList) && isEmpty(find(availableOutputDevices, selectedOutputDeviceInfo.selectedOutputDevice)))
            || selectedOutputDeviceInfo.selectedOutputDevice !== fallbackDevice) {
            selectedOutputDeviceInfo.selectedOutputDevice = fallbackDevice || null;
        }
    }
    else {
        selectedOutputDeviceInfo.selectedOutputDevice = fallbackDevice || null;
    }
};
export function deviceReducer(state, action) {
    if (state === void 0) { state = INITIAL_STATE; }
    switch (action.type) {
        case DeviceActions.SET_AVAILABLE: {
            var setAvailableAction = action;
            var newState_1 = __assign({}, state, { labelledOutputDevices: state.labelledOutputDevices ? state.labelledOutputDevices : new Map() });
            // We may not have the full state yet, so fill up the missing pieces
            if (!newState_1.videoTrackConstraints) {
                newState_1.videoTrackConstraints = INITIAL_STATE.videoTrackConstraints;
            }
            if (typeof newState_1.selectInputReady === 'undefined') {
                newState_1.selectInputReady = INITIAL_STATE.selectInputReady;
            }
            if (typeof newState_1.screenShare === 'undefined') {
                newState_1.screenShare = INITIAL_STATE.screenShare;
            }
            if (typeof newState_1.selectedVideoInputBitRate === 'undefined') {
                newState_1.selectedVideoInputBitRate = INITIAL_STATE.selectedVideoInputBitRate;
            }
            if (setAvailableAction.payload) {
                newState_1.allDevices = mergeByDeviceUID(setAvailableAction.payload, newState_1.allDevices);
                var inputDevices = getInputDevices(setAvailableAction.payload);
                var outputDevices = getOutputDevices(setAvailableAction.payload);
                var videoInputDevices = getVideoInputDevices(setAvailableAction.payload);
                var outputDevicesRemovedList_1 = differenceByDeviceUID(newState_1.availableOutputDevices, outputDevices);
                var videoInputDevicesRemovedList = differenceByDeviceUID(newState_1.availableVideoInputDevices, videoInputDevices);
                if (!areDeviceListsEqual(newState_1.availableInputDevices, inputDevices) || !newState_1.selectedInputDevice) {
                    newState_1.availableInputDevices = inputDevices;
                    var fallbackDevice = getNextDevice(newState_1.selectedInputDeviceHistory, newState_1.availableInputDevices);
                    if (newState_1.selectedInputDevice) {
                        /**
                         * We re-select the device in those cases
                         * 1. If the previously selected device is NOT in the list of available devices, that device is not available
                         *    Example: perviously selected device is plugged out.
                         * 2. If the previously selected device is NOT in the current selected device or the current default device
                         *    Nuanced case: when we have empty history and we plug in new device and operational system places that device on top of the device list
                         *    then this device became devices[0] which means default device for this package
                         */
                        if (isEmpty(find(newState_1.availableInputDevices, newState_1.selectedInputDevice)) || newState_1.selectedInputDevice !== fallbackDevice) {
                            newState_1.selectedInputDevice = fallbackDevice || null;
                        }
                    }
                    else {
                        newState_1.selectedInputDevice = fallbackDevice || null;
                    }
                }
                if (!areDeviceListsEqual(newState_1.availableVideoInputDevices, videoInputDevices) || !newState_1.selectedVideoInputDevice) {
                    newState_1.availableVideoInputDevices = videoInputDevices;
                    if (newState_1.selectedVideoInputDevice) {
                        if (!isEmpty(videoInputDevicesRemovedList)) {
                            if (isEmpty(find(newState_1.availableVideoInputDevices, newState_1.selectedVideoInputDevice))) {
                                var fallbackDevice = getNextDevice(newState_1.selectedVideoInputDeviceHistory, newState_1.availableVideoInputDevices);
                                newState_1.selectedVideoInputDevice = fallbackDevice || null;
                            }
                        }
                    }
                }
                if (!areDeviceListsEqual(newState_1.availableOutputDevices, outputDevices)) {
                    newState_1.availableOutputDevices = outputDevices;
                    setAvailableOutputDevice(newState_1.availableOutputDevices, outputDevicesRemovedList_1, newState_1);
                    newState_1.labelledOutputDevices = new Map(__spread(newState_1.labelledOutputDevices.entries()).map(function (_a) {
                        var _b = __read(_a, 2), label = _b[0], outputDeviceInfo = _b[1];
                        var updatedOutputDeviceInfo = __assign({}, outputDeviceInfo);
                        setAvailableOutputDevice(newState_1.availableOutputDevices, outputDevicesRemovedList_1, updatedOutputDeviceInfo);
                        return [label, updatedOutputDeviceInfo];
                    }));
                }
                else {
                    if (!newState_1.selectedOutputDevice) {
                        setAvailableOutputDevice(newState_1.availableOutputDevices, outputDevicesRemovedList_1, newState_1);
                    }
                    if (__spread(newState_1.labelledOutputDevices.values()).some(function (outputDeviceInfo) { return !outputDeviceInfo.selectedOutputDevice; })) {
                        newState_1.labelledOutputDevices = new Map(__spread(newState_1.labelledOutputDevices.entries()).map(function (_a) {
                            var _b = __read(_a, 2), label = _b[0], outputDeviceInfo = _b[1];
                            var updatedOutputDeviceInfo = __assign({}, outputDeviceInfo);
                            setAvailableOutputDevice(newState_1.availableOutputDevices, outputDevicesRemovedList_1, updatedOutputDeviceInfo);
                            return [label, updatedOutputDeviceInfo];
                        }));
                    }
                }
            }
            return newState_1;
        }
        case DeviceActions.SET_INPUT: {
            var setInputAction = action;
            var newDevice = setInputAction.payload;
            if (newDevice && newDevice.kind === 'audioinput') {
                if (state.selectInputReady) {
                    return __assign({}, state, { selectedInputDeviceHistory: updateDeviceHistory(state.selectedInputDeviceHistory, deviceUID(newDevice)), selectedInputDevice: newDevice });
                }
            }
            return state;
        }
        case DeviceActions.SET_INPUT_READY: {
            var setInputStateAction = action;
            var inputState = setInputStateAction.payload;
            if (typeof (inputState) !== 'undefined') {
                return __assign({}, state, { selectInputReady: inputState });
            }
            return state;
        }
        case DeviceActions.SET_OUTPUT: {
            var setOutputAction = action;
            var newDevice = setOutputAction.payload;
            if (newDevice && newDevice.kind === 'audiooutput') {
                return __assign({}, state, { selectedOutputDeviceHistory: updateDeviceHistory(state.selectedOutputDeviceHistory, deviceUID(newDevice)), selectedOutputDevice: newDevice });
            }
            return state;
        }
        case DeviceActions.SET_LABELLED_OUTPUT: {
            var setSpeakerOutputAction = action;
            if (setSpeakerOutputAction.payload) {
                var _a = setSpeakerOutputAction.payload, newDevice = _a.device, label = _a.label;
                if (newDevice && newDevice.kind === 'audiooutput') {
                    var newLabelledOutputDevices = new Map(state.labelledOutputDevices);
                    newLabelledOutputDevices.set(label, __assign({}, state.labelledOutputDevices.get(label), { selectedOutputDeviceHistory: updateDeviceHistory(state.selectedOutputDeviceHistory, deviceUID(newDevice)), selectedOutputDevice: newDevice }));
                    return __assign({}, state, { labelledOutputDevices: newLabelledOutputDevices });
                }
            }
            return state;
        }
        case DeviceActions.SET_OUTPUT_MUTED: {
            var setOutputMutedAction = action;
            return __assign({}, state, { outputDeviceMuted: setOutputMutedAction.payload });
        }
        case DeviceActions.SET_LABELLED_OUTPUT_MUTED: {
            var setSpeakerOutputMutedAction = action;
            if (setSpeakerOutputMutedAction.payload) {
                var _b = setSpeakerOutputMutedAction.payload, muted = _b.muted, label = _b.label;
                var outputDeviceInfo = state.labelledOutputDevices.get(label);
                if (outputDeviceInfo) {
                    var newLabelledOutputDevices = new Map(state.labelledOutputDevices);
                    newLabelledOutputDevices.set(label, __assign({}, outputDeviceInfo, { outputDeviceMuted: muted }));
                    return __assign({}, state, { labelledOutputDevices: newLabelledOutputDevices });
                }
            }
            return state;
        }
        case DeviceActions.SET_VIDEO_INPUT: {
            var setVideoInputAction = action;
            var newDevice = setVideoInputAction.payload;
            if (newDevice && newDevice.kind === 'videoinput') {
                if (state.selectInputReady) {
                    return __assign({}, state, { selectedVideoInputDeviceHistory: updateDeviceHistory(state.selectedVideoInputDeviceHistory, deviceUID(newDevice)), selectedVideoInputDevice: newDevice });
                }
                return state;
            }
            return __assign({}, state, { selectedVideoInputDevice: null });
        }
        case DeviceActions.SET_VIDEO_INPUT_BIT_RATE: {
            var setVideoInputBitRateAction = action;
            var newBitRate = setVideoInputBitRateAction.payload;
            // Bitrate can be unlimited of a positive integer. Return previous state if invalid payload or the default 500 kbps if no payload.
            if (newBitRate) {
                if ((typeof newBitRate === 'number' && newBitRate > 0) || newBitRate === 'unlimited') {
                    if (state.selectedVideoInputBitRate) {
                        return __assign({}, state, { selectedVideoInputBitRate: newBitRate });
                    }
                }
                return state;
            }
            return __assign({}, state, { selectedVideoInputBitRate: 500 });
        }
        case DeviceActions.SET_SCREEN_SHARE: {
            var setScreenShareAction = action;
            var screenShared = setScreenShareAction.payload;
            if (screenShared === 'screen' || screenShared === 'window' ||
                screenShared === 'desktop' || screenShared === 'tab') {
                return __assign({}, state, { screenShare: screenShared });
            }
            return __assign({}, state, { screenShare: null });
        }
        case DeviceActions.SET_VIDEO_TRACK_CONSTRAINTS: {
            var setVideoResolutionAction = action;
            var constraints = setVideoResolutionAction.payload;
            if (constraints && constraints.width && constraints.height) {
                var newVideoTrackConstraints = {
                    width: constraints.width,
                    height: constraints.height
                };
                if (constraints.frameRate) {
                    if (constraints.frameRate >= 2 && constraints.frameRate <= 60) {
                        newVideoTrackConstraints.frameRate = constraints.frameRate;
                    }
                    return __assign({}, state, { videoTrackConstraints: __assign({}, state.videoTrackConstraints, newVideoTrackConstraints) });
                }
                return __assign({}, state, { videoTrackConstraints: __assign({}, newVideoTrackConstraints) });
            }
            return state;
        }
        case DeviceActions.INPUT_FALLBACK_FINISH: {
            var inputFallbackFinishAction = action;
            var newState = __assign({}, state);
            if (typeof inputFallbackFinishAction.payload !== 'undefined') {
                if (!devicesEqual(state.selectedInputDevice, inputFallbackFinishAction.payload.audioDevice)) {
                    newState.selectedInputDevice = inputFallbackFinishAction.payload.audioDevice;
                }
                if (!devicesEqual(state.selectedVideoInputDevice, inputFallbackFinishAction.payload.videoDevice)) {
                    newState.selectedVideoInputDevice = inputFallbackFinishAction.payload.videoDevice;
                }
            }
            return newState;
        }
        default:
            return state || INITIAL_STATE;
    }
}
//# sourceMappingURL=devices.reducer.js.map